import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { GuardianInvite, ProfileInfo } from '@se-po/shared-data-access-models'
import { AddGuardianComponent } from '@se-po/shared-ui-add-guardian'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import {
  CentralServiceResources as cs,
} from 'se-resource-types'

@Component({
  selector: 'se-po-household-invite',
  templateUrl: './household-invite.component.html',
  styleUrls: ['./household-invite.component.scss'],
})
export class HouseholdInviteComponent implements OnInit {
  @ViewChild('inviteControls') public inviteControls: AddGuardianComponent
  @Input() public prohibitedEmails?: string[] = []
  @Output() public invite: EventEmitter<GuardianInvite> = new EventEmitter()

  public loading: boolean
  public submitting: boolean
  public fullName: string
  public emailNotAllowed = false

  constructor(
    public seFeTranslationsLoader: SeFeTranslationsLoader,
    public translateService: TranslateService,
    private formService: SeFeFormService
  ) {}

  @Input() public set profile(profile: (cs.Profiles.Persona | ProfileInfo)) {
    if ('first_name' in profile) {
      this.fullName = `${profile?.first_name} ${profile?.last_name}`
    }
    else if ('firstName' in profile) {
      this.fullName = `${profile?.firstName} ${profile?.lastName}`
    }
    else{
      this.fullName = 'child'
    }
  }

  public async ngOnInit(): Promise<void> {
    this.loading = true
    this.loadTranslations()
  }

  async loadTranslations(): Promise<void> {
    await this.seFeTranslationsLoader.load('shared/feature-household-invite/assets/translations').then(() => {
      this.loading = false
    })
  }

  public reset(): void {
    this.inviteControls.reset()
  }

  public sendInvite(): void {
    this.submitting = true
    const inviteForm = this.inviteControls.form

    if(this.formService.isValid(inviteForm)) {
      if(!this.prohibitedEmails.find(item => item === inviteForm.value.email)) {
        this.invite.emit(inviteForm.value)
      }
      else {
        this.emailNotAllowed = true
      }
    }
    this.submitting = false
  }

  public skipInvite(): void {
    this.invite.emit(null)
  }
}
